<template>
    <div class="red-packet-main g-flex g-flex-column">
        <div class="g-flex-center-center">
            <div class="title-icon"></div>
            <div class="title g-flex-center-center" v-if="!store.mainData.isEnd">
                <p>本轮已获得</p>
                <p class="title-num q-number">{{ store.mainData.today_help_count }}</p>
                <p>个红包</p>
            </div>
            <div class="title title-end" v-else>本次活动已结束</div>
            <div class="title-icon title-icon-r"></div>
        </div>
        <p class="subtitle">每日最高可得</p>
        <div class="num-box g-flex">
            <p class="num q-number">{{ store.mainData.pool_amount || '--' }}</p>
            <p class="unit">元</p>
        </div>
        <p class="tip">每日 12:00 开启</p>
        <div class="btn" @click="onInvite" v-if="!store.mainData.isEnd">邀请助力瓜分红包</div>
        <div class="btn btn-disabled" v-else>请关注后续活动</div>
    </div>
</template>
<script lang="ts" setup>
import { ref, getCurrentInstance } from 'vue';
import { useStore } from '@divide/store';
import { useStoreCommon } from '@qm-activity/common/store/common';
import { openLogin, jsbSupportMap } from '@q-front-npm/jsbridge';
const instance = getCurrentInstance()!;
const store = useStore();
const storeCommon = useStoreCommon();
const onInvite = () => {
    if (!storeCommon.userInfo.isLogin) {
        openLogin();
        return;
    }
    if (jsbSupportMap.app.share) {
        store.setPopManage('share', true);
    } else {
        instance.proxy.$toast('请更新至最新版本以参与活动');
    }
};
</script>
<style lang="scss" scoped>
.red-packet-main {
    margin-top: 32px;
    padding-top: 8px;

    width: 100%;
    height: 568px;
    background: url('@divide/assets/images/divide_mainredpacket@3x.png') no-repeat center;
    background-size: auto 100%;
    position: relative;
    align-items: center;
}
.title {
    height: 52px;
    background: #fff1dd;

    font-size: 22px;
    color: #854242;
    line-height: 1;
    padding: 0 1px;

    &-end {
        line-height: 52px;
    }

    &-num {
        font-weight: bold;
        font-size: 32px;
        color: #ff2020;
        line-height: 1;
        margin: 0 2px 2px;
    }

    &-icon {
        margin-right: -1px;
        width: 48px;
        height: 52px;
        background: url('@divide/assets/images/divide_yuanjiao@3x.png') no-repeat;
        background-size: 100% 100%;

        &-r {
            transform: rotateY(180deg);
            margin-left: -1px;
        }
    }
}
.subtitle {
    margin-top: 44px;
    font-weight: bold;
    font-size: 28px;
    color: #9c2020;
    line-height: 40px;
}

.num-box {
    margin-top: -12px;
    margin-left: 6px;
}
.num {
    font-weight: bold;
    font-size: 120px;
    color: #fa2b40;
    line-height: 144px;
}
.unit {
    margin-left: 8px;
    margin-top: 68px;
    font-weight: bold;
    font-size: 36px;
    color: #fa2b40;
    line-height: 50px;
}
.tip {
    width: 280px;
    height: 44px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff5e7 24.48%, #fff1dd 50.55%, rgba(255, 241, 221, 0.6) 80.85%, rgba(255, 255, 255, 0) 100%);
    font-size: 24px;
    color: #854242;
    line-height: 44px;
    text-align: center;
}

.btn {
    position: absolute;
    bottom: 56px;
    left: 88px;
    right: 88px;
    height: 88px;
    line-height: 88px;
    text-align: center;
    font-weight: bold;
    color: #7f300d;
    font-size: 34px;
    &-disabled {
        opacity: 0.4;
    }
}
</style>
